/*
  CRO 2026-09-26: free varnish on "Buy it now" too.
  "Buy it now" goes straight to checkout, so cro-free-gift.js (cart drawer) never ran, and the
  automatic ₹79 "FREE Varnish" discount applied with no varnish in the order (#EA11014).
  When the selected kit x quantity reaches the ₹2,599 threshold, this catches the real Buy it now
  click, adds the kit (with every line property, incl. the Uploadly photo) plus the varnish to the
  cart, shows a short "free varnish added" celebration and then opens checkout.
  Below the threshold Buy it now works exactly as before.
  Uploadly shows its own copy of the button (data-clone-button) until a photo is uploaded; that copy
  is left alone so its "please upload" check still runs.
  Config: window.CRO_OFFERS (snippets/cro-cart-reassurance.liquid).
*/
(() => {
  if (window.__croBuyNowGift) return;
  window.__croBuyNowGift = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let bypass = false;
  let running = false;

  const productForm = () =>
    document.querySelector('product-form form[action*="/cart/add"]') ||
    document.querySelector('form[id^="product-form-template"]');

  const variantPrice = (id) => {
    const p = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    const v = p && (p.variants || []).find((x) => String(x.id) === String(id));
    return v ? Number(v.price) : null; // paise
  };

  // form.id would return the <input name="id">, so read the attribute
  const quantity = (form) => {
    const q = document.querySelector(`input[name="quantity"][form="${form.getAttribute('id')}"]`) ||
      form.querySelector('input[name="quantity"]');
    return Math.max(1, parseInt(q && q.value, 10) || 1);
  };

  // Uploadly keeps this input disabled until the photo is uploaded; the real Buy it now button is
  // only back on the page after that, so a disabled id here means "don't touch it".
  const variantId = (form) => {
    const i = form.querySelector('input[name="id"]');
    return i && !i.disabled ? i.value : null;
  };

  function qualifies(form) {
    const cfg = window.CRO_OFFERS;
    if (!cfg || !form) return false;
    const id = variantId(form);
    if (!id || String(id) === String(cfg.giftVariant)) return false;
    const price = variantPrice(id);
    return price !== null && price * quantity(form) >= cfg.giftMin;
  }

  function celebrate() {
    const style = document.createElement('style');
    style.textContent = `
      .cro-bn{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;
        background:rgba(0,0,0,.45);animation:cro-bn-in .2s ease-out}
      .cro-bn__card{background:#fff;color:#1a1a1a;border-radius:18px;padding:2.4rem 2.2rem;max-width:32rem;margin:0 1.6rem;
        text-align:center;box-shadow:0 12px 40px rgba(0,0,0,.25);animation:cro-bn-pop .45s cubic-bezier(.2,1.4,.4,1)}
      .cro-bn__emoji{font-size:4.4rem;line-height:1}
      .cro-bn__title{font-size:2.2rem;font-weight:700;margin:.8rem 0 .4rem}
      .cro-bn__sub{font-size:1.45rem;opacity:.75;margin:0}
      .cro-bn canvas{position:fixed;inset:0;pointer-events:none}
      @keyframes cro-bn-in{from{opacity:0}to{opacity:1}}
      @keyframes cro-bn-pop{from{transform:scale(.6);opacity:0}to{transform:scale(1);opacity:1}}`;
    const wrap = document.createElement('div');
    wrap.className = 'cro-bn';
    wrap.setAttribute('role', 'status');
    wrap.innerHTML = `<canvas></canvas><div class="cro-bn__card"><div class="cro-bn__emoji">🎉</div>
      <p class="cro-bn__title">Yay! Free varnish added</p>
      <p class="cro-bn__sub">15 ml high-gloss varnish, on us. Taking you to checkout…</p></div>`;
    document.head.appendChild(style);
    document.body.appendChild(wrap);

    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    const c = wrap.querySelector('canvas');
    const ctx = c.getContext('2d');
    const dpr = window.devicePixelRatio || 1;
    c.width = innerWidth * dpr;
    c.height = innerHeight * dpr;
    ctx.scale(dpr, dpr);
    const colors = ['#FF6B6B', '#FFD93D', '#6BCB77', '#4D96FF', '#C77DFF', '#FF9F45'];
    const bits = Array.from({ length: 140 }, () => ({
      x: innerWidth / 2, y: innerHeight / 2,
      vx: (Math.random() - 0.5) * 16, vy: Math.random() * -15 - 4,
      w: 6 + Math.random() * 6, h: 8 + Math.random() * 8,
      r: Math.random() * Math.PI, vr: (Math.random() - 0.5) * 0.3,
      color: colors[(Math.random() * colors.length) | 0],
    }));
    const start = performance.now();
    (function frame(t) {
      ctx.clearRect(0, 0, innerWidth, innerHeight);
      bits.forEach((b) => {
        b.vy += 0.45; b.vx *= 0.99; b.x += b.vx; b.y += b.vy; b.r += b.vr;
        ctx.save(); ctx.translate(b.x, b.y); ctx.rotate(b.r);
        ctx.fillStyle = b.color; ctx.fillRect(-b.w / 2, -b.h / 2, b.w, b.h); ctx.restore();
      });
      if (t - start < 2200) requestAnimationFrame(frame);
    })(start);
  }

  const postJSON = (url, body) =>
    fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });

  // Cart already holds what the shopper is buying: add the varnish if the kits reach the threshold,
  // celebrate, then open checkout. Also used by the mobile sticky bar's "Buy it now"
  // (sections/mobile-sticky-atc.liquid), which adds to cart and then jumps to checkout.
  async function giftThenCheckout() {
    const cfg = window.CRO_OFFERS;
    window.__croCheckingOut = true; // keeps cro-cart-celebrate.js's toast quiet; this flow has its own
    try {
      if (cfg) {
        const isGift = (i) => i.properties && i.properties._free_gift;
        const getCart = async () => (await fetch(`${root}cart.js`)).json();
        const wait = (ms) => new Promise((r) => setTimeout(r, ms));
        let cart = await getCart();
        const chosen = cart.items.filter((i) => !isGift(i));
        const base = chosen.reduce((s, i) => s + i.original_line_price, 0);
        const own = chosen.some((i) => i.variant_id === cfg.giftVariant);
        if (!own && base >= cfg.giftMin) {
          // After an add-to-cart, cro-free-gift.js (cart drawer) adds the varnish itself ~50 ms later.
          // Give it a moment so we don't both add one; add it ourselves only if it didn't.
          for (let i = 0; i < 8 && !cart.items.some(isGift); i++) {
            await wait(150);
            cart = await getCart();
          }
          let gift = cart.items.some(isGift);
          if (!gift) {
            gift = (await postJSON('cart/add.js', {
              items: [{ id: cfg.giftVariant, quantity: 1, properties: { _free_gift: '1' } }],
            })).ok;
          }
          if (gift) {
            celebrate();
            await wait(1800);
            // last check before checkout: exactly one free varnish
            const g = (await getCart()).items.find(isGift);
            if (g && g.quantity > 1) await postJSON('cart/change.js', { id: g.key, quantity: 1 });
          }
        }
      }
    } catch (e) {
      console.warn('[cro-buynow-gift]', e);
    }
    window.location.href = `${root}checkout`;
  }
  window.croGiftThenCheckout = giftThenCheckout;

  async function buyNowWithGift(form, button) {
    running = true;
    window.__croCheckingOut = true;
    button.setAttribute('aria-busy', 'true');
    try {
      const fd = new FormData(form);
      fd.set('id', variantId(form));
      fd.set('quantity', String(quantity(form)));
      fd.delete('sections');
      // Uploadly (custom kits) writes the photo link as properties[...] inputs, possibly into another
      // cart form on the page. Bring every line property along so the order keeps the photo.
      document.querySelectorAll('form[action*="/cart/add"] [name^="properties["]').forEach((el) => {
        if (el.disabled || fd.has(el.name) || ((el.type === 'checkbox' || el.type === 'radio') && !el.checked)) return;
        if (el.value !== '') fd.append(el.name, el.value);
      });
      const add = await fetch(`${root}cart/add.js`, { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      if (!add.ok) throw new Error(`cart/add ${add.status}`);
      await giftThenCheckout();
    } catch (e) {
      console.warn('[cro-buynow-gift] falling back to normal Buy it now', e);
      running = false;
      window.__croCheckingOut = false;
      button.removeAttribute('aria-busy');
      bypass = true;
      button.click();
      bypass = false;
    }
  }

  window.addEventListener(
    'click',
    (e) => {
      if (bypass) return;
      const button = e.target.closest && e.target.closest('.shopify-payment-button__button');
      if (!button || button.closest('[data-clone-button]')) return; // Uploadly's copy: let it check the upload
      if (running) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }
      const form = productForm();
      if (!qualifies(form)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      buyNowWithGift(form, button);
    },
    true
  );
})();
